import BaseReportStore from './base-store'
import publisherStore from 'modules/offer/stores/publisher'
import allocationStore from 'modules/offer/stores/allocation'
import integrationStore from 'modules/settings/stores/integration'
import metaFieldStore from 'modules/settings/stores/meta-field'

export default new class integrationReport extends BaseReportStore {
  constructor() {
    super(true)
  }

  endpointReport = 'integration'

  publisher = this.attachEntity(publisherStore, { params: { report: false } })
  allocation = this.attachEntity(allocationStore, { labelKey: 'description', params: { report: false } })
  integration = this.attachEntity(integrationStore, { labelKey: 'description', params: { report: false } })
  metaField = this.attachEntity(metaFieldStore, {
    labelKey: 'key',
    valueKey: 'key',
    labelFn: ({ value }) => value,
  });
  get data() {
    return this.collection.data
  }

}
